import {
  GetSessionStorageData,
  SetSessionStorageData,
  nullUndefinedEmptyCheck,
} from "../Helpers/Helper";
import {
  API_RESPONSE,
  ROUTES,
  TOKENS,
} from "../../Utilities/Constants/Constants";
import { toast } from "react-toastify";
import API_END_POINTS from "../../Utilities/Constants/ApiEndpoints";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setLoader } from "../Redux/Reducer/loader";
import { store } from "../Redux/Store/Store";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_BACKEND_API_URL,
});
axiosInstance.interceptors.request.use(
  (config: any): any => {
    if ((config.url.split('?')[0] !== API_END_POINTS.CHAT_USERS_LIST) && (config.url.split('?')[0] !== API_END_POINTS.NOTIFICATIONS_LIST)) {
    store.dispatch(setLoader(true));
    }
    const accessToken = GetSessionStorageData(TOKENS.ACCESS_TOKEN);
    const temporaryToken = GetSessionStorageData(TOKENS.TEMPORARY_TOKEN);
    if(nullUndefinedEmptyCheck(temporaryToken)){
      config.headers["Authorization"] = "Bearer " + `${temporaryToken}`;
    }else
    if (nullUndefinedEmptyCheck(accessToken)) {
      config.headers["Authorization"] = "Bearer " + `${accessToken}`;
    }
    if (config.url === API_END_POINTS.SCHOOL_BULK_UPLOAD) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error: any): any => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response: any): any => {
    store.dispatch(setLoader(false));
    return response;
  },
  (error: any): any => {
    store.dispatch(setLoader(false));
    if (
      error?.response?.status === 401 &&
      error.request.responseURL !==
        `${process.env.REACT_APP_BASE_BACKEND_API_URL}` +
          `${API_END_POINTS.REFRESH_TOKEN}`
    ) {
      const refreshToken = GetSessionStorageData(TOKENS.REFRESH_TOKEN);
      if (nullUndefinedEmptyCheck(refreshToken)) {
        let payload: any = {
          refresh: refreshToken,
        };
        axiosInstance
          .post(API_END_POINTS.REFRESH_TOKEN, payload)
          .then((response: any) => {
            if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
              SetSessionStorageData(TOKENS.REFRESH_TOKEN, response.data.access);
            }
          });
      } else {
        useNavigate()(ROUTES.LOGIN);
      }
    } else {
      toast.error(error?.response?.data?.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
    return Promise.reject(error);
  }
);
export { axiosInstance };
